import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import OperationalGaps from './components/OperationalGaps';
import SolutionOverview from './components/SolutionOverview';
import HowItWorks from './components/HowItWorks';
import ReadinessLayer from './components/ReadinessLayer';
import Differentiation from './components/Differentiation';
import GeographicFocus from './components/GeographicFocus';
import WhyBrightSync from './components/WhyBrightSync';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.text = JSON.stringify([
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "BrightSync",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com",
        "logo": "https://static.readdy.ai/image/3bf68d6c09283a962d249fcc9ea91526/ab1e605b7823c60e0472793f0d68ad5d.png",
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "arunk@bright-sync.com",
          "contactType": "customer service",
          "areaServed": "US-TX"
        },
        "areaServed": [
          { "@type": "City", "name": "Austin", "containedInPlace": { "@type": "State", "name": "Texas" } },
          { "@type": "City", "name": "Dallas-Fort Worth", "containedInPlace": { "@type": "State", "name": "Texas" } }
        ],
        "description": "BrightSync improves response predictability and operational visibility for high-urgency data center components through structured coordination and SLA-style tracking in Austin and DFW Texas."
      },
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "BrightSync",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com",
        "logo": "https://static.readdy.ai/image/3bf68d6c09283a962d249fcc9ea91526/ab1e605b7823c60e0472793f0d68ad5d.png",
        "email": "arunk@bright-sync.com",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "TX",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 30.2672,
          "longitude": -97.7431
        },
        "serviceArea": [
          { "@type": "City", "name": "Austin" },
          { "@type": "City", "name": "Dallas-Fort Worth" }
        ],
        "description": "Critical parts readiness coordination for data center operations in Texas."
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Texas Data Center Critical Parts Readiness | BrightSync",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com",
        "description": "BrightSync improves response predictability and operational visibility for high-urgency data center components through structured coordination and SLA-style tracking in Austin and DFW Texas.",
        "inLanguage": "en-US",
        "isPartOf": {
          "@type": "WebSite",
          "name": "BrightSync",
          "url": import.meta.env.VITE_SITE_URL || "https://example.com"
        }
      }
    ]);
    if (!document.getElementById('schema-home')) {
      document.head.appendChild(script);
    }
    return () => {
      const existing = document.getElementById('schema-home');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <OperationalGaps />
      <SolutionOverview />
      <HowItWorks />
      <ReadinessLayer />
      <Differentiation />
      <GeographicFocus />
      <WhyBrightSync />
      <FinalCTA />
      <Footer />
    </div>
  );
}
